import FilterFactory from '@/lib/filterFactory';

export default class PartnerGroupsFilter {
    filterHandlers = {
        update: 'partnerGroupsFilter/updateFilter',
        reset: 'partnerGroupsFilter/resetFilter',
        resetState: 'partnerGroupsFilter/resetFilterState',
        removeSelected: 'partnerGroupsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createRadioEntity('isActive');
        filter.setTitle('isActive', 'Группа активна');
        filter.setName('isActive', 'radio_is_active');
        filter.setPreviewName('isActive', 'Активна');
        filter.setRadioList('isActive', [
            { id: 0, name: 'Активна', checked: false },
            { id: 1, name: '', checked: false },
            { id: 2, name: 'Не активна', checked: false },
        ]);
        filter.setAction('isActive', 'partnerGroupsFilter/updateRadio');
        filter.setClassName('isActive', 'col-1-row-3');

        this.filterModel = filter.filterModel;
    }
}
